import React, { useState } from 'react'; 

 
   const SummaryModal = ({ onClose, data }) => {
  return (
    <div className="summary-overlay">
      <div className="summary-container">
        {/* Header Section from image_3cd2c9 */}
        <div className="summary-header-blue">
          <div className="header-left">
            <div className="header-title">
              <i className="fas fa-clipboard-check me-2"></i>
              Project Summary & Verification
            </div>
            <p className="header-subtitle">Please review all details before final submission</p>
          </div>
          <div className="header-id-badge">
            MES-PR-JVFFC8B3IDFZVB0F
          </div>
          <button className="summary-close" onClick={onClose}>&times;</button>
        </div>

        <div className="summary-body">
          {/* Property Details Grid */}
          <section className="summary-section">
            <h5 className="section-title">
              <i className="fas fa-info-circle text-primary me-2"></i> Property Details
              <span className="status-ready">Ready for Processing</span>
            </h5>
            <div className="summary-grid">
              <div className="summary-info-box">
                <label>PROPERTY ADDRESS</label>
                <div>{data.address}</div>
              </div>
              <div className="summary-info-box">
                <label>LOT AREA</label>
                <div>{data.lotArea}</div>
              </div>
              <div className="summary-info-box">
                <label>PROJECT CREATED</label>
                <div>{data.created}</div>
              </div>
              <div className="summary-info-box">
                <label>PROJECT STATUS</label>
                <div>{data.status}</div>
              </div>
            </div>
          </section>

          {/* Report Configuration from image_3cd019 */}
          <section className="summary-section mt-4">
            <h5 className="section-title">
              <i className="fas fa-file-alt text-primary me-2"></i> Report Configuration
            </h5>
            <div className="report-type-box">
              <label>SELECTED REPORT TYPE</label>
              <div className="type-purple">{data.reportType}</div>
            </div>
            
            <label className="features-label mt-3">FEATURES COVERED</label>
            <div className="features-badge-container">
              {data.features.map(f => (
                <span key={f} className="feature-badge-pill">{f}</span>
              ))}
            </div>
          </section>

          {/* Pricing & Discounts from image_3ccfbd */}
          <section className="summary-section mt-4">
            <h5 className="section-title">
              <i className="fas fa-calculator text-primary me-2"></i> Pricing & Discounts
            </h5>
            <div className="pricing-box">
               <div className="price-row">
                 <span>Base Estimate</span>
                 <span>{data.total}</span>
               </div>
               <div className="price-row final-total">
                 <span>Final Total</span>
                 <span>{data.total}</span>
               </div>
            </div>
          </section>
        </div>

        {/* Modal Footer */}
        <div className="summary-footer">
          <button className="btn-back" onClick={onClose}>
            <i className="fas fa-arrow-left me-2"></i> Back to Edit
          </button>
          <button className="btn-confirm">
            <i className="fas fa-check-circle me-2"></i> Confirm & Generate Report
          </button>
        </div>
      </div>
    </div>
  );
};

export default SummaryModal;